import { Base } from '@gate31/core/src/libs/BaseComponent';
import { ProductReviewsHeader } from '@gate31/feature/ProductReviewsHeader/ProductReviewsHeader';

export class ProductReviewsHeaderDesk extends ProductReviewsHeader {
    static cn = new Base.BuildCn('ProductReviewsHeaderDesk');
}
